/* eslint-disable
    func-names,
    no-shadow,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// Collection of all SubscriptionPlan.
const deps = ['SubscriptionPlan', 'Collection', 'GatewayApi'];
const factory = function (SubscriptionPlan, Collection, GatewayApi) {
  let SubscriptionPlanCollection;
  return (SubscriptionPlanCollection = (function () {
    SubscriptionPlanCollection = class SubscriptionPlanCollection extends Collection {
      static initClass() {
        this.prototype.$id = 'single';
        this.prototype.$resource = 'billing';
        this.prototype.$apiService = GatewayApi;
        this.prototype.$type = SubscriptionPlan;
      }

      $url() {
        return 'billing/plans';
      }
    };
    SubscriptionPlanCollection.initClass();
    return SubscriptionPlanCollection;
  })());
};

factory.$inject = deps;

const moduleDeps = [require('data/model/subscriptionPlan').name, require('data/util').name];

module.exports = angular
  .module('bench.data.collection.subscriptionPlan', moduleDeps)
  .factory('SubscriptionPlanCollection', factory);
